import React from 'react';
import Dialog from '#lib/components/dialog.jsx';
import { cn } from '#lib/helpers/class.js';
import FloatingTooltip from './tooltip.jsx';
import { Icon } from '@iconify-icon/react';

export function DocumentsModal(props) {
    const { onEdit, planDocuments, itineraryDocuments, dayId, planId, isOpen, onClose } = props;

    const planDocs = planDocuments ?? [];

    const handleDeleteDocument = (docId) => {
        const newDocs = planDocs.filter((_, i) => i !== docId);
        onEdit([dayId, planId], 'documents', newDocs);
    };

    const handleAddDocument = (docId) => onEdit([dayId, planId], 'documents', [...planDocs, docId]);

    return (
        <Dialog className="fixed inset-0 isolate overflow-auto" isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="ml-[50vw] -translate-x-[50%] mt-[50vh] -translate-y-[50%] flex flex-col space-y-4 w-1/3 max-w-[460px]">
                <div className="pr-4">
                    <Dialog.CloseButton />
                    <b>{_t.edit.documentsText()}</b>
                    <p className="pr-2 mt-1 text-sm">{_t.edit.documentsSubText()}</p>
                </div>

                <div className="max-h-[300px] overflow-auto">
                    {itineraryDocuments &&
                        itineraryDocuments.map((doc) => {
                            return (
                                <div key={doc.id} className="w-full flex justify-between items-center gap-x-6">
                                    <div className="w-full flex justify-start items-center gap-x-2">
                                        <FloatingTooltip content={_t.edit.document()}>
                                            <Icon icon="mdi:file-document-outline" width="1.2rem" height="1.2rem" />
                                        </FloatingTooltip>
                                        <span className="whitespace-nowrap text-ellipsis overflow-hidden w-0 flex-grow">
                                            {doc.name}
                                        </span>
                                    </div>
                                    <div className="flex gap-x-4">
                                        <button
                                            className={cn(
                                                'py-1 w-20 my-1 rounded bg-primary-500 text-white hover:bg-primary-600',
                                                planDocs.includes(doc.id) && 'opacity-50 hover:cursor-not-allowed'
                                            )}
                                            onClick={() => handleAddDocument(doc.id)}
                                            disabled={planDocs.includes(doc.id)}
                                        >
                                            Add
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                <div className="max-h-[300px] overflow-auto">
                    {planDocuments && planDocuments.length > 0 && (
                        <div className="mt-4">
                            <p>{'Linked documents: '}</p>
                            <ul>
                                {planDocuments.map((doc, index) => {
                                    return (
                                        <li key={index} className="w-full py-2 flex justify-between items-center">
                                            <div className="flex gap-x-2 items-center">
                                                <FloatingTooltip content={_t.edit.document()}>
                                                    <Icon
                                                        icon="mdi:file-document-outline"
                                                        width="1.2rem"
                                                        height="1.2rem"
                                                    />
                                                </FloatingTooltip>
                                                <span>
                                                    {itineraryDocuments?.find((document) => document.id === doc)?.name}
                                                </span>
                                            </div>
                                            <FloatingTooltip content={_t.global.delete()}>
                                                <Icon
                                                    icon="ph:trash"
                                                    width="1.3rem"
                                                    height="1.3rem"
                                                    className="mr-4 cursor-pointer"
                                                    onClick={() => handleDeleteDocument(index)}
                                                />
                                            </FloatingTooltip>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
